import { render, staticRenderFns } from "./LastUpdate.vue?vue&type=template&id=5c177cff"
import script from "./LastUpdate.vue?vue&type=script&lang=js"
export * from "./LastUpdate.vue?vue&type=script&lang=js"
import style0 from "./LastUpdate.vue?vue&type=style&index=0&id=5c177cff&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports